import {useApiContext} from "../context";

export const useApi = () => useApiContext();
